module.exports = __webpack_public_path__ + "media/bootstrap-icons/currency-euro-4f9c677f.svg";